// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"358":"07b70609","515":"b3414e9d"}[chunkId] + ".chunk.js";
};